import { combineReducers } from "redux";
import authReducer from "./authReducers";
import errorReducer from "./errorReducers";
import weatherReducer from "./weatherReducers";

export default combineReducers({
    auth: authReducer,
    errors: errorReducer,
    weather: weatherReducer
});